import $ from 'jquery';

const installmentPaymentV1Semantics = {
    mainWrapClass: 'installment-payment-v1',
    popupContainerClass: 'installment-payment-modal-v1_popup',
    isInitializedAttribute: 'data-is-initialized',
    instanceIdAttribute: 'data-instance-id',
    submitClass: 'installment-payment-v1__submit',
    activeElementClass: 'installment-payment-v1__item-active',
    successClass: 'installment-payment-v1__success',
    errorFieldClass: 'installment-payment-v1__error',
    closeModal: 'installment-payment-modal-v1__close',
    errorClass: 'js-error-popup',
    hideClass: 'installment-payment-v1__hide',
}

$(function () {
    let roots = $(`.${installmentPaymentV1Semantics.mainWrapClass}`);
    if (roots.length === 0) {
        return false;
    }
    let installmentPaymentV1 = new InstallmentPaymentV1();
    /**
     * Checking other instances
     */
    roots.each((index, el) => {
        let isInitialized =
            ($(el).attr(`${installmentPaymentV1Semantics.isInitializedAttribute}`) === 'true');

        if (!isInitialized) {
            installmentPaymentV1.registerInstance($(el));
            installmentPaymentV1.registerListeners($(el));
        }
    });
})

class InstallmentPaymentV1 {

    constructor() {
        this.pluginInstances = {};
    }

    registerInstance(el) {
        let instanceId =
            el.attr(`${installmentPaymentV1Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        try {
            let object = el.find(`.${installmentPaymentV1Semantics.mainWrapClass}`);
            el.attr(`${installmentPaymentV1Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = object;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el) {
        let instanceID = el.attr(installmentPaymentV1Semantics.instanceIdAttribute);
        //let instanceObj = $(`#${instanceID}`);
        let elements = $(`.${installmentPaymentV1Semantics.mainWrapClass}[${
                installmentPaymentV1Semantics
                        .instanceIdAttribute
        }="${
                el.attr(installmentPaymentV1Semantics
                        .instanceIdAttribute)
        }"]`);
        elements.click(function (e) {
                e.preventDefault();
                let current = $(e.currentTarget);
                let popup = $(`.${installmentPaymentV1Semantics.popupContainerClass}`);
                popup.show();
        });

        $(`.${installmentPaymentV1Semantics.closeModal}`).click(function (e) {
            e.preventDefault();
            //let current = $(e.currentTarget);
            let popup = $(`.${installmentPaymentV1Semantics.popupContainerClass}`);
            popup.hide();
        });
    }
}

export default InstallmentPaymentV1;